<script>
    // svelte
    import { createEventDispatcher } from 'svelte';

    // DB
    import { client, gql, reset } from "../GraphQL.svelte";

    // actions
    import { logout } from "../Auth.svelte";
    import { deleteMe } from "../Me.svelte";
    import { deleteCompany, deleteAll as deleteAllCompanies } from "../Company.svelte";
    import { deleteAllProjects } from "../Participaid.svelte";
    import Seed from "../lib/seed.js";

    // elements
    import Notification from "../components/Notification.svelte";

    //
    // locals
    //

    let projectIdToDelete;
    let companyIdToSeed = "160ecfef-d7e1-4a5f-94d1-ede687808514";
    let projectIdToSeed;
    let seedAsOwner = true;

    let notificationText;

    let errorText;

    //
    // constants
    //

    const dispatch = createEventDispatcher();

    const unauth = () => dispatch("auth");

    function onError(err) {
        errorText = JSON.stringify(err);
    }

    function run(name, req) {
        req.then(res => {
            notificationText = `finished ${name}`;
        })
        .catch(onError);
    }

    function deleteMyAccount() {
        run("deleted account", deleteMe());
        run("apollo.js store reset", reset());
    }

    function clean() {
        run("deleting all companies", deleteAllCompanies());
        run("deleting all projects", deleteAllProjects());
        run("apollo.js store reset", reset());
    }

    function deleteProject() {
        run("deleted project", 
            deleteProjectById(projectIdToDelete));
    }

    function seedCompany() {
        run("seeded company", Seed.newProject(companyIdToSeed, !!seedAsOwner));
    }

    function seedProject() {
        run(Seed.project(projectIdToSeed));
    }
</script>

<div class="container">
    <h1>Admin</h1>

    <div class="action">
        <p>Logs out current user and redirects to login</p>
        <button on:click={unauth}>logout</button>
    </div>

    <div class="action">
        <p>Delete all data from user account</p>
        <button on:click={clean}>clean</button>
    </div>

    <div class="action">
        <p>Delete this user account</p>
        <button on:click={deleteMyAccount}>delete</button>
    </div>

    <div class="action">
        <p>Reset Apollo.js store</p>
        <button on:click={reset}>reset</button>
    </div>

    <div class="action">
        <p>Delete project</p>
        <div><input bind:value="{projectIdToDelete}" placeholder="project ID..." type="text"/><button on:click={deleteProject}>delete</button></div>
    </div>

    <div class="action">
        <p>Seed demo project</p>
        <div><input type="checkbox" checked:seedAsOwner/> As project owner</div>
        <div><input bind:value="{companyIdToSeed}" placeholder="company ID..." type="text"/><button on:click={seedCompany}>seed</button></div>
    </div>

    <div class="action">
        <p>Seed existing project</p>
        <div><input type="checkbox" checked:seedAsOwner/> As project owner</div>
        <div><input bind:value="{projectIdToSeed}" placeholder="project ID..." type="text"/><button on:click={seedProject}>seed</button></div>
    </div>
</div>

<Notification message={notificationText} type="success" />
<Notification message={errorText} type="error" />

<style>
    .container {
        width: 600px;
        margin: auto;
        background: white;
    }
</style>